import React from 'react'

export const ResourceCardSkeleton = () => {
  return (
    <div className="resources__card--skeleton">
      <div className="resources__card--skeleton-image"></div>
      <div className="resources__card--skeleton-tag"></div>
      <div className="resources__card--skeleton-content">
        <div className="resources__card--skeleton-meta">
          <div className="resources__card--skeleton-topic"></div>
          <div className="resources__card--skeleton-date"></div>
        </div>
        <div className="resources__card--skeleton-title"></div>
      </div>
    </div>
  )
}

export const FilterButtonSkeleton = () => {
  return (
    <div className="resources__filter--skeleton">
      <div className="resources__filter--skeleton-button"></div>
    </div>
  )
}

export const FilterBarSkeleton = () => {
  return (
    <div className="row">
<div className="resources__filters--skeleton">
      <div className="resources__filters--skeleton-mobile">
        <div className="resources__filters--skeleton-mobile-button"></div>
      </div>
      
      <div className="resources__filters--skeleton-desktop">
        <div className="resources__filters--skeleton-label"></div>
        <div className="resources__filters--skeleton-filters">
          <FilterButtonSkeleton />
          <FilterButtonSkeleton />
          <FilterButtonSkeleton />
          <FilterButtonSkeleton />
          <div className="resources__filters--skeleton-search"></div>
        </div>
      </div>
    </div>
    </div>
    
  )
}

export default FilterBarSkeleton
